// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DeL7","label":"styles_label__IemzA"};